import React, { memo, useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import AppPageHeader from '../../../components/AppPageHeader'
import { EmptyText, WordBreak } from '../../../components/Common/CellText'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import PDFViewer from '../../../components/PDFViewer/PDFViewer'
import PopupHandleDocumentOutgoing from './PopupHandleDocumentOutgoing'
// Layout
import DashboardLayout from '../../../layouts/DashboardLayout'
// Styled Component
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
} from '../../../layouts/InternalDocumentDetailLayout/InternalDocumentDetailLayoutStyled'
import { UserListWrapper } from './InternalDocumentOutgoingDocDetailPageStyled'
// Antd
import {
  CalendarOutlined,
  DeleteOutlined,
  HistoryOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  SendOutlined,
  SolutionOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  Dropdown,
  Form,
  Menu,
  message,
  Modal,
  Row,
  Tabs,
  Tooltip,
} from 'antd'
// PDF Viewer
import { useMediaQuery } from 'react-responsive'
// Mobx
import { inject, observer } from 'mobx-react'
// Other
import moment from 'moment'
import queryString from 'query-string'
import { blue } from '../../../color'
import AccessControlAction from '../../../components/AccessControlAction'
import {
  MenuDotsBoldIcon,
  PenOutlineIcon,
  SettingsOutlineIcon,
} from '../../../components/AppIcon'
import { KeyValueItem } from '../../../components/Common/KeyValueItem'
import LinkedTask from '../../../components/Common/Linked/LinkedTask'
import LinkedWork from '../../../components/Common/Linked/LinkedWork'
import PopoverWatchTime from '../../../components/PopoverWatchTime'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent/SpinnerInlineComponent'
import { systemName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_DEFAULT,
  DOCUMENT_TYPE,
  VIEWLOG_DATE,
} from '../../../constants'
import utils from '../../../utils'
import InternalDocumentComment from '../InternalDocumentComment'
import PopupPhanPhatDocument from '../PopupPhanPhatDocument'
import PopupHandleHistory from './PopupHandleDocumentOutgoing/PopupHandleHistoryOutgoing'
const { confirm } = Modal

const renderInfoText = string => {
  if (string) {
    if (string.length <= 20) return string
    return (
      <Tooltip title={string}>{string.substring(0, 20).concat('...')}</Tooltip>
    )
  }
}

const InternalDocumentOutgoingDocDetailPage = props => {
  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const [form] = Form.useForm()

  const {
    match,
    commonStore,
    authenticationStore,
    internalDocumentStore,
    loadingAnimationStore,
    history,
    connectedDocumentStore,
    selectPeopleStore,
    aclStore,
  } = props

  const { documentId } = match.params

  const { currentUser } = authenticationStore
  const currentUserName = currentUser?.username
  // Không xóa dòng khai báo aclActionsByUser (dù k dùng)
  const { aclActionsByUser } = aclStore

  const {
    selectedInternalDocumentOutgoing,
    followerAssignList,
  } = internalDocumentStore

  const {
    title,
    document_number,
    date_issued,
    authority_issued_id,
    agency_issued,
    signer,
    outgoing_date,
    attachments,
    linkedTask,
    linkedWork,
    created_at,
  } = selectedInternalDocumentOutgoing

  const [attachmentForView, setAttachmentForView] = useState()
  const [isLoadingComment, setIsLoadingComment] = useState(false)
  const [
    isVisiblePopupPhanPhatDocument,
    setIsVisiblePopupPhanPhatDocument,
  ] = useState(false)
  const [
    isVisiblePopupHandleDocument,
    setIsVisiblePopupHandleDocument,
  ] = useState(false)
  const [
    isVisiblePopupHistoryDocument,
    setIsVisiblePopupHistoryDocument,
  ] = useState(false)
  const [departWithUsers, setDepartWithUsers] = useState([])
  useEffect(() => {
    ;(async () => {
      try {
        await selectPeopleStore.getDepartmentWithUsers()
        const response = await selectPeopleStore.getDepartmentWithUsersV2()
        setDepartWithUsers(response.data)
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      }
    })()
  }, [])

  useEffect(() => {
    ;(async () => {
      try {
        await selectPeopleStore.getDepartmentWithUsers()
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      }
    })()
  }, [])

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.name))
      )
    )
  }, [attachments])

  const renderAttachment = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.id}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.name)}
        fileName={attachmentForView?.name}
      />
    ),
    [attachmentForView]
  )

  const renderAuthorityIssuedList = (authorityIssuedId, agencyIssued) => {
    const authorityList = []
    if (authorityIssuedId) {
      authorityList.push(authorityIssuedId.name)
    }
    if (agencyIssued && agencyIssued !== authorityIssuedId?.name) {
      authorityList.push(agencyIssued)
    }
    if (authorityIssuedId || agencyIssued) {
      return authorityList.join(', ')
    }
    return <EmptyText>Không có cơ quan ban hành.</EmptyText>
  }

  const handleDeleteDocument = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await internalDocumentStore.deleteOutgoingInternalDocumentById(documentId)
      history.push('/internal-document/outgoing-document')
      message.success('Xóa văn bản thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showConfirmDeleteDocument = () => {
    confirm({
      title: 'Bạn có muốn xóa văn bản này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteDocument()
      },
    })
  }

  const handleReceiveDocumentToTruc = () => {
    connectedDocumentStore.setDataReceiveDocument(
      selectedInternalDocumentOutgoing
    )
    history.push('/connected-document/outgoing-document/create')
  }

  const handleReceiveDocumentToUBQLV = () => {
    connectedDocumentStore.setDataReceiveDocument(
      selectedInternalDocumentOutgoing
    )
    history.push('/connected-committee-document/outgoing-document/create')
  }

  const menuHandleDocument = (
    <Menu>
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.history__OUTGOING) && (
        <Menu.Item
          onClick={() => setIsVisiblePopupHistoryDocument(true)}
          icon={<HistoryOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Lịch sử</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.lienthong_vimc__OUTGOING
      ) && (
        <Menu.Item
          onClick={handleReceiveDocumentToTruc}
          style={{ color: blue }}
          icon={<SendOutlined style={{ color: blue }} />}>
          Đi liên thông văn bản {systemName}
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.lienthong_ubqlv__OUTGOING
      ) && (
        <Menu.Item
          onClick={handleReceiveDocumentToUBQLV}
          style={{ color: blue }}
          icon={<SendOutlined />}>
          Đi liên thông văn bản UBQLV
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tao_nv_tu_vb__OUTGOING
      ) && (
        <Menu.Item
          onClick={() =>
            history.push(
              `/mission/create?document_code=${documentId}&title=${title}&type=OUTGOING`
            )
          }
          icon={<ProfileOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Tạo nhiệm vụ từ văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tao_cv_tu_vb__OUTGOING
      ) && (
        <Menu.Item
          onClick={() => {
            const documentList = attachments.map(el => el.id + '/' + el.name)
            const queryStringParams = queryString.stringify(
              {
                document_list: documentList,
                document_title: title,
                document_code: documentId,
                document_type: DOCUMENT_TYPE.OUTGOING,
              },
              { arrayFormat: 'index' }
            )
            history.push(`/works/create?${queryStringParams}`)
          }}
          icon={<SolutionOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Tạo công việc từ văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.delete__OUTGOING) && (
        <Menu.Item
          danger
          onClick={showConfirmDeleteDocument}
          icon={<DeleteOutlined />}>
          Xóa văn bản
        </Menu.Item>
      )}
    </Menu>
  )

  useEffect(() => {
    ;(async () => {
      try {
        loadingAnimationStore.showSpinner(true)
        await internalDocumentStore.getInternalDocumentOutgoingById(documentId)
      } catch (err) {
        history.push('/internal-document/outgoing-document')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      form.resetFields()
      internalDocumentStore.clearSelectedInternalDocumentOutgoing()
      selectPeopleStore.clearSelected()
      internalDocumentStore.clearAssignList()
    }
  }, [documentId])

  return (
    <DashboardLayout>
      <Helmet>
        <title>{`${title} | ${systemName} Quản lý VB nội bộ`}</title>
      </Helmet>
      <AppPageHeader
        title={title}
        showBackButton
        addon={
          <>
            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.edit__OUTGOING
            ) && (
              <Button
                icon={<PenOutlineIcon style={{ width: 16, height: 16 }} />}
                className="custom-ant-button icon-btn"
                type="default"
                onClick={() =>
                  history.push(
                    `/internal-document/outgoing-document/${documentId}`
                  )
                }>
                Chỉnh sửa văn bản
              </Button>
            )}
            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.xuly__OUTGOING
            ) && (
              <Button
                icon={<SettingsOutlineIcon style={{ width: 16, height: 16 }} />}
                className="custom-ant-button icon-btn"
                type="default"
                onClick={() => setIsVisiblePopupHandleDocument(true)}>
                Xử lý văn bản
              </Button>
            )}
            <Dropdown overlay={menuHandleDocument} trigger={['click']}>
              <Button
                style={{ width: 40, height: 40, flexShrink: 0 }}
                icon={
                  <MenuDotsBoldIcon
                    style={{
                      width: 20,
                      height: 20,
                      transform: 'rotate(90deg)',
                    }}
                  />
                }
                className="custom-ant-button icon-btn"
                type="default"
              />
            </Dropdown>
          </>
        }
      />

      <DocumentContentWrapper>
        <BlockLeft>{renderAttachment}</BlockLeft>
        <BlockRight>
          <div className="internal-doc-content-card">
            <h3 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600 }}>
              Thông tin chung
            </h3>
            <Row gutter={[20, 16]}>
              <Col span={12}>
                <KeyValueItem
                  label="Số hiệu"
                  value={renderInfoText(document_number)}
                />
              </Col>

              <Col span={12}>
                <KeyValueItem
                  label="Ngày ban hành"
                  value={
                    date_issued ? (
                      <>
                        <CalendarOutlined
                          style={{ color: blue, marginRight: 4 }}
                        />
                        <span>
                          {moment(date_issued).format(DATE_FORMAT_DEFAULT)}
                        </span>
                      </>
                    ) : (
                      <EmptyText>Không rõ ngày ban hành.</EmptyText>
                    )
                  }
                />
              </Col>

              <Col span={12}>
                <KeyValueItem
                  label="Người ký"
                  value={
                    signer ? signer : <EmptyText>Không có người ký</EmptyText>
                  }
                />
              </Col>

              <Col span={12}>
                <KeyValueItem
                  label="Cơ quan ban hành"
                  value={WordBreak(
                    renderAuthorityIssuedList(
                      authority_issued_id,
                      agency_issued
                    )
                  )}
                />
              </Col>

              <Col span={24}>
                <KeyValueItem
                  label="Tài liệu đính kèm"
                  value={
                    attachments ? (
                      attachments
                        .sort((a, b) => a.name.localeCompare(b.name)) // Sắp xếp theo tên file
                        .map(file => (
                          <FileItem
                            key={file.id}
                            file_id={file.id}
                            file_name={file.name}
                            file_type={utils.getExtensionFile(file.name)}
                          />
                        ))
                    ) : (
                      <EmptyText>Không có tài liệu đính kèm</EmptyText>
                    )
                  }
                />
              </Col>

              <Col span={24}>
                <KeyValueItem
                  label="Liên kết nhiệm vụ"
                  value={
                    <LinkedTask
                      linkedTaskList={linkedTask}
                      documentCode={documentId}
                      onSuccess={() =>
                        internalDocumentStore.getInternalDocumentOutgoingById(
                          documentId
                        )
                      }
                    />
                  }
                />
              </Col>
              <Col span={24}>
                <KeyValueItem
                  label="Liên kết công việc"
                  value={
                    <LinkedWork
                      linkedWorkList={linkedWork}
                      documentCode={documentId}
                      onSuccess={() =>
                        internalDocumentStore.getInternalDocumentOutgoingById(
                          documentId
                        )
                      }
                    />
                  }
                />
              </Col>
            </Row>
          </div>

          <div className="internal-doc-content-card">
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="Xử lý văn bản" key="1">
                <UserListWrapper>
                  <div
                    style={{
                      display: 'flex',
                      flexGrow: 1,
                      marginTop: 8,
                      marginBottom: 8,
                    }}>
                    <b>Theo dõi:</b>
                    {followerAssignList.length > 0 ? (
                      <PopoverWatchTime
                        departWithUsers={departWithUsers}
                        userList={followerAssignList}
                        title={'Danh sách người theo dõi'}
                        isFullViewer={true}
                        compared_date={VIEWLOG_DATE.internal_document_until}
                        typeId={documentId}
                        created_at={created_at}
                      />
                    ) : (
                      <EmptyText>Không có người theo dõi.</EmptyText>
                    )}
                  </div>
                </UserListWrapper>
                <AccessControlAction
                  aclActionType={ACL_ACTION_TYPE.phanphat__OUTGOING}>
                  <Button
                    type="primary"
                    onClick={() => setIsVisiblePopupPhanPhatDocument(true)}
                    className="custom-ant-button"
                    style={{
                      width: '100%',
                    }}>
                    Phân phát
                  </Button>
                </AccessControlAction>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Ý kiến" key="2">
                <InternalDocumentComment
                  documentId={documentId}
                  setIsLoadingComment={bool => setIsLoadingComment(bool)}
                />
                <SpinnerInlineComponent
                  sizeSpin={'small'}
                  isLoading={isLoadingComment}
                />
              </Tabs.TabPane>
            </Tabs>
          </div>
        </BlockRight>
      </DocumentContentWrapper>
      <PopupHandleDocumentOutgoing
        isVisiblePopupHandleDocument={isVisiblePopupHandleDocument}
        currentUser={currentUser}
        handleCancelHandleDocument={() =>
          setIsVisiblePopupHandleDocument(false)
        }
        handleCloseHandleDocument={() => setIsVisiblePopupHandleDocument(false)}
      />

      <PopupHandleHistory
        isVisiblePopupHistoryDocument={isVisiblePopupHistoryDocument}
        documentCode={documentId}
        handleCancelHistoryDocument={() =>
          setIsVisiblePopupHistoryDocument(false)
        }
        handleCloseHistoryDocument={() =>
          setIsVisiblePopupHistoryDocument(false)
        }
      />

      <PopupPhanPhatDocument
        typeDocument={DOCUMENT_TYPE.OUTGOING}
        selectedInternalDocument={selectedInternalDocumentOutgoing}
        isVisiblePopupPhanPhatDocument={isVisiblePopupPhanPhatDocument}
        handleClosePopupPhanPhatDocument={() =>
          setIsVisiblePopupPhanPhatDocument(false)
        }
      />
    </DashboardLayout>
  )
}

InternalDocumentOutgoingDocDetailPage.propTypes = {}

export default memo(
  inject(
    'commonStore',
    'internalDocumentStore',
    'loadingAnimationStore',
    'authenticationStore',
    'departmentStore',
    'staffStore',
    'connectedDocumentStore',
    'selectPeopleStore',
    'aclStore'
  )(observer(InternalDocumentOutgoingDocDetailPage))
)
